var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"5"}},[_c('v-sheet',{staticClass:"rounded-lg shadow",attrs:{"color":"white","height":"100%"}},[_c('user-authentication')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }